// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import WalletIcon from "@material-ui/icons/Flight";
import Money from "@material-ui/icons/Money"

import DashboardPage from "views/Dashboard/Dashboard.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import BillablePassengers from "views/BillablePassengers/Index.jsx";
import PSCUtilization from "views/PSCUtilization/Index.jsx";
import Audit from "@material-ui/icons/TrackChanges";
import Audits from "views/AuditTrail/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import WalletReport from "views/WalletReport";
import StatementOfAccount from "views/StatementOfAccount/Index.jsx"
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";


const routes = [
  {
    path: "/landing",
    sidebarName: "Home",
    navbarName: "Home",
    icon: Dashboard,
    component: DashboardPage,
      subMenu: [],
  },
  {
    path: "/",
    sidebarName: "Airline Payment",
    isNotVisible: true,
    navbarName: "Dashboard",
    icon: Passenger,
      subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
      subMenu: [],
      component: AirlinePaymentPage
  },
    {
        path: "/app/wallet-report",
        sidebarName: "Airline Wallet Report",
        isNotVisible: false,
        navbarName: "Airline Wallet Report",
        icon: WalletIcon,
        component: WalletReport,
        subMenu: [],

    },
  {
    path: "/app/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
      subMenu: [],
      component: SettlementPage
  },
  {
    path: "/app/outstanding-settlement",
    sidebarName: "Outstanding Settlement",
    navbarName: "Outstanding Settlement",
    icon: Settlement,
      subMenu: [],
      component: OutstandingSettlementPage
  },
  // {
  //   path: "/reports-landing",
  //   sidebarName: "PSC Reports",
  //   navbarName: "Psc Reports",
  //   icon: Report,
  //   component: Reports,
  //     subMenu: [],

  // },
  {
      path: "/app/psc-utilization",
      sidebarName: "PSC Utilization",
      isNotVisible: true,
      navbarName: "PSC Utilization",
      icon: Dashboard,
      component: PSCUtilization,
      subMenu: [],

  },
  {
      path: "/app/billable-passengers",
      sidebarName: "Billable Passengers",
      isNotVisible: true,
      navbarName: "Total Passengers vs Billable Passengers",
      icon: BillablePassengers,
      component: BillablePassengers,
      subMenu: [],

  },
    {
        path: "/app/statement-of-account",
        sidebarName: "Account Statement",
        isNotVisible: false,
        navbarName: "Account Statement",
        icon: Money,
        component: StatementOfAccount,
        subMenu: []
    },
    {
        path: "/app/audits",
        sidebarName: "Audit Trail",
        navbarName: "Audit Trails",
        isNotVisible: true,
        icon: Audit,
        subMenu: [],
        component: Audits,
    },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
    ];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/airline.jsx